import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M5.625 8.625L12 15.375L18.375 8.625' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.59192 8.17968C4.76972 7.76719 5.17585 7.5 5.62503 7.5H18.375C18.8242 7.5 19.2303 7.76719 19.4081 8.17968C19.5859 8.59217 19.5013 9.07089 19.1929 9.39745L12.8179 16.1475C12.6054 16.3725 12.3095 16.5 12 16.5C11.6905 16.5 11.3947 16.3725 11.1821 16.1475L4.80714 9.39745C4.49872 9.07089 4.41411 8.59217 4.59192 8.17968ZM8.23495 9.75L12 13.7365L15.7651 9.75H8.23495Z'
            />
        </SvgIcon>
    );
});
